var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4821 10.7945L1.26842 0.0805007C0.89879 -0.0873523 0.457729 0.0126453 0.200593 0.330495C-0.0583287 0.648344 -0.067257 1.10012 0.179165 1.4269L7.8129 11.6052L0.179165 21.7835C-0.067257 22.1103 -0.0583287 22.5639 0.198808 22.8799C0.372017 23.096 0.630939 23.2121 0.893433 23.2121C1.02022 23.2121 1.147 23.1853 1.26664 23.1299L24.4803 12.4159C24.7982 12.2695 25 11.9534 25 11.6052C25 11.257 24.7982 10.9409 24.4821 10.7945Z",
    fill: "#555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/send-message-icon.26b10875257c035c4984bd45895087ac.svg";
export { ForwardRef as ReactComponent };